import DTO from './DTO';

class TariffDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'tariff_file',
        type: String,
        validators: [],
        labelKey: 'media.tariff_file',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default TariffDTO;
